import AuthService from '../services/auth.service';

const auth_token = JSON.parse(localStorage.getItem('auth_token'));
const initialState = auth_token
  ? { status: { loggedIn: true }, auth_token ,shelterAccount : auth_token.shelterAccount, userinfo : auth_token.userinfo}
  : { status: { loggedIn: false }, auth_token: null ,shelterAccount : null, userinfo: null};

export const auth = {
  namespaced: true,
  state: initialState,
  actions: {
    login({ commit }, user) {

      return AuthService.login(user).then(
        auth_token => {

          if(auth_token.result == 'success'){
            commit('loginSuccess', auth_token);
            return Promise.resolve(auth_token);
          }
          
        },
        error => {
          commit('loginFailure');
          return Promise.reject(error);
        }
      );
    },
    logout({ commit }) {
      AuthService.logout();
      commit('logout');
    },
    register({ commit }, user) {
      return AuthService.register(user).then(
        response => {
          commit('registerSuccess');
          return Promise.resolve(response.data);
        },
        error => {
          commit('registerFailure');
          return Promise.reject(error);
        }
      );
    },

// 🔹 보호소 정보 업데이트 액션
    updateShelterInfo({ commit }, newShelter) {
      // 1) Vuex state 갱신
      commit('SET_SHELTER_INFO', newShelter);

      // 2) localStorage 안의 auth_token.shelterAccount도 같이 갱신
      const stored = JSON.parse(localStorage.getItem('auth_token'));
      if (stored) {
        stored.shelterAccount = newShelter; // token 필드는 건드리지 않음
        localStorage.setItem('auth_token', JSON.stringify(stored));
      }
    },
  },
  mutations: {
    loginSuccess(state, auth_token) {
      state.status.loggedIn = true;
      state.auth_token = auth_token;              // 🔹 state에 auth_token도 같이 저장
      state.userinfo = auth_token.userinfo;
      state.shelterAccount = auth_token.shelterAccount;
      
    },
    loginFailure(state) {
      state.status.loggedIn = false;
      state.userinfo = null;
      state.shelterAccount = null;
    },
    logout(state) {
      state.status.loggedIn = false;
      state.userinfo = null;
      state.shelterAccount = null;

    },
    registerSuccess(state) {
      state.status.loggedIn = false;
    },
    registerFailure(state) {
      state.status.loggedIn = false;
    },
    // 🔹 새로 추가하는 뮤테이션
    SET_SHELTER_INFO(state, newShelter) {
      state.shelterAccount = newShelter;

      // state.auth_token 안에도 shelterAccount 같이 반영해두면
      // 컴포넌트에서 auth_token을 보고 있는 경우에도 값이 맞음
      if (state.auth_token) {
        state.auth_token = {
          ...state.auth_token,
          shelterAccount: newShelter
        };
      }
    }

  }
};